<div class="card-summary">
  <div class="card-summary-header">
    <div class="card-summary-header__info">
      <h3>{{ "LABELS.INTERNAL_NOTES" | translate }}</h3>
      <app-hint-tooltip-icon [hint]="enumHintKey.internalNotesCardHint"></app-hint-tooltip-icon>
      <div class="message-label">
        {{ "LABELS.INTERNAL_NOTES_MESSAGE" | translate }}
      </div>
    </div>
    <div class="card-summary-header__edit" (click)="openInternalNotes()">
      <img src="assets/icons/edit_gray.svg" />
      <span class="pl-1">{{ "BUTTON.EDIT" | translate }}</span>
    </div>
  </div>
  <div class="card-summary-body">
    <div class="card-summary-body__item">
      <span class="card-summary-body__item-title">{{ "FORM_LABEL.INTERNAL_REF" | translate }}</span>
      <span class="card-summary-body__item-value">{{ product.internalReferenceNumber }}</span>
    </div>
    <div class="card-summary-body__item">
      <span class="card-summary-body__item-title">{{ "LABELS.NOTES" | translate }}</span>
      <div class="card-summary-body__item-value">
        <!--        TODO: UNCOMMENT AFTER #7822-->
        <!--        <text-editor [content]="product.internalNotes" [isViewMode]="true"></text-editor>-->
        <span>{{ product.internalNotes }}</span>
      </div>
    </div>
  </div>
</div>
